// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const postApi = baseApi.injectEndpoints({
  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    getAllPosts: builder.query({
      query: () => {
        return {
          url: "post",
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ["Posts"],
    }),
    getPostDetails: builder.query({
      query: (id) => {
        return {
          url: `post/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["Posts"],
    }),
    getPostComments: builder.query({
      query: (id) => {
        return {
          url: `post/${id}/comment`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ["Posts"],
    }),
    deletePost: builder.mutation({
      query: (id) => {
        return {
          url: `post/${id}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ["Posts"],
    }),
    deletePostComment: builder.mutation({
      query: (id) => {
        return {
          url: `post/comment/${id}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["Posts"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllPostsQuery,
  useGetPostDetailsQuery,
  useGetPostCommentsQuery,
  useDeletePostMutation,
  useDeletePostCommentMutation,
} = postApi;
